import React, { useState } from 'react';
import { Image } from 'antd';
import useTrackerMediaUrls from '../hooks/useTrackerMediaUrls';

/**
 * 队员消息媒体附件（图片 / 视频 / 语音）。签名 URL 短期有效，由 useTrackerMediaUrls 自动续签。
 * 过期 / 已清理 / 存储未配置时显示占位说明，不影响文本显示。
 */
function seconds(ms) {
  const n = Number(ms);
  return Number.isFinite(n) && n > 0 ? `${Math.max(1, Math.round(n / 1000))} 秒` : '';
}

function VideoItem({ item }) {
  const [poster, setPoster] = useState(item.poster_url || undefined);
  return (
    <video
      controls
      preload="metadata"
      poster={poster}
      onError={() => setPoster(undefined)}
      style={{ maxWidth: 280, maxHeight: 220, borderRadius: 6, background: '#0f172a', display: 'block' }}
    >
      <source src={item.url} type={item.mime === 'video/quicktime' ? 'video/mp4' : item.mime} />
      <track kind="captions" />
    </video>
  );
}

export default function TrackerMediaAttachments({ media }) {
  const { items, error, loading } = useTrackerMediaUrls(media);
  if (!Array.isArray(media) || media.length === 0) return null;

  const placeholder = (text) => (
    <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 4 }}>{text}</div>
  );
  if (error) {
    return placeholder(error.code === 'media_disabled' ? '媒体存储未配置，无法显示附件' : `附件加载失败：${error.message}`);
  }
  if (loading && items.length === 0) return placeholder('附件加载中…');

  const images = [];
  const others = [];
  media.forEach((m, i) => {
    const item = items[i];
    if (!item) {
      others.push(<div key={m.media_id}>{placeholder('附件已过期或已清理')}</div>);
    } else if (item.kind === 'image') {
      images.push(item);
    } else if (item.kind === 'video') {
      others.push(<VideoItem key={item.media_id} item={item} />);
    } else {
      others.push(
        <div key={item.media_id} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <audio controls preload="none" src={item.url} style={{ height: 32, maxWidth: 260 }} />
          <span style={{ fontSize: 12, color: '#64748b' }}>{seconds(item.duration_ms)}</span>
        </div>
      );
    }
  });

  return (
    <div style={{ marginTop: 6, display: 'flex', flexDirection: 'column', gap: 6 }}>
      {images.length > 0 ? (
        <Image.PreviewGroup>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {images.map((item) => (
              <Image
                key={item.media_id}
                src={item.thumb_url || item.url}
                preview={{ src: item.url }}
                width={images.length > 1 ? 96 : 160}
                height={images.length > 1 ? 96 : undefined}
                style={{ objectFit: 'cover', borderRadius: 6 }}
                fallback={item.url}
                alt="队员图片"
              />
            ))}
          </div>
        </Image.PreviewGroup>
      ) : null}
      {others}
    </div>
  );
}